import { useTranslation } from "react-i18next";
import { Control, FieldValues, Path, PathValue } from "react-hook-form";
import { countriesOptions } from "@/constants/options/customs.option";
import { CustomReducedDto } from "@/types/api/api-types";
import { ControlledSelectV2 } from "./controlled-select-v2";
import { Option } from "./select-v2";

const renderCustomOptionLabel = (option: Option) => {
  const countryCode = option.countryCode as string | undefined;
  return (
    <div className="flex flex-row items-center gap-2">
      {countryCode && countryCode !== "" && (
        <img
          src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${countryCode.toUpperCase()}.svg`}
          className="h-4 w-4"
          alt=""
        />
      )}
      <div>{option.label}</div>
    </div>
  );
};

const renderCustomValueLabel = (option: Option | undefined) => {
  if (!option) return null;
  return renderCustomOptionLabel(option);
};

interface ControlledCustomsSelectProps<T extends FieldValues> {
  disabled?: boolean;
  name: Path<T>;
  control: Control<T>;
  customs: CustomReducedDto[];
  label?: string;
  placeholder?: string;
  searchPlaceholder?: string;
  contentClassName?: string;
  defaultValue?: PathValue<T, Path<T>>;
  setValue?: (value: string) => void;
}

export const ControlledCustomsSelect = <T extends FieldValues>({
  control,
  name,
  customs,
  label,
  placeholder = "",
  searchPlaceholder,
  contentClassName = "w-full",
  defaultValue,
  disabled,
  setValue,
}: ControlledCustomsSelectProps<T>) => {
  const { t } = useTranslation("shared");
  return (
    <ControlledSelectV2
      options={countriesOptions(customs)}
      control={control}
      name={name}
      contentClassName={contentClassName}
      label={label}
      renderOption={renderCustomOptionLabel}
      renderValue={renderCustomValueLabel}
      placeholder={placeholder}
      searchable
      searchPlaceholder={searchPlaceholder ?? t("customsSelect.searchPlaceholder")}
      defaultValue={defaultValue}
      setValue={setValue}
      isDisabled={disabled}
    />
  );
};
